<template>
  <div>
    <div class="personalForm">
      <div class="form">
        <el-form
          :model="formLabelAlign"
          label-width="120px"
          size="small"
          style="overflow: hidden"
          ref="formLabelAlign"
          disabled
        >
          <div class="codeIcon">基本信息</div>
          <div class="elFormBox">
            <el-form-item label="用户名">
              <el-input
                v-model="formLabelAlign.account"
                style="width: 300px"
                placeholder="请输入用户名"
              ></el-input>
            </el-form-item>
            <el-form-item label="客户名称" prop="userName">
              <el-input
                v-model="formLabelAlign.userName"
                style="width: 300px"
                placeholder="请输入客户名称"
              ></el-input>
            </el-form-item>
          </div>
          <div class="elFormBox">
            <el-form-item label="注册手机">
              <el-input
                v-model="formLabelAlign.mobilePhone"
                style="width: 300px"
                placeholder="请输入注册手机号"
              ></el-input>
            </el-form-item>
            <el-form-item label="联系电话" prop="linkUserPhone">
              <el-input
                v-model="formLabelAlign.linkUserPhone"
                style="width: 300px"
                placeholder="请输入联系电话"
              ></el-input>
            </el-form-item>
          </div>
          <div class="elFormBox">
            <el-form-item label="身份证号码" prop="idCard">
              <el-input
                v-model="formLabelAlign.idCard"
                style="width: 300px"
                placeholder="请输入身份证号码"
              ></el-input>
            </el-form-item>
            <el-form-item label="个人所在地" prop="city">
              <el-input
                v-model="formLabelAlign.city"
                style="width: 300px"
                placeholder="请输入身份证号码"
              ></el-input>
            </el-form-item>
          </div>
          <div class="idCars">
            <el-form-item label="身份证照片"></el-form-item>
            <div style="position: relative">
              <div class="avatar-box">
                <img :src="carImg" alt="" />
              </div>
            </div>
          </div>
          <div class="codeIcon">收款信息</div>
          <div class="elFormBox">
            <el-form-item label="收款人姓名" prop="bankAccountName">
              <el-input
                v-model="formLabelAlign.bankAccountName"
                style="width: 300px"
                placeholder="请输入收款信息"
              ></el-input>
            </el-form-item>
            <el-form-item label="开户行" prop="depositBank">
              <el-input
                v-model="formLabelAlign.depositBank"
                style="width: 300px"
                placeholder="请输入"
              ></el-input>
            </el-form-item>
          </div>
          <div class="elFormBox">
            <el-form-item label="银行卡号" prop="bankAccount">
              <el-input
                v-model="formLabelAlign.bankAccount"
                style="width: 300px"
                placeholder="请输入银行卡号"
              ></el-input>
            </el-form-item>
          </div>
        </el-form>
      </div>
    </div>
  </div>
</template>

<script>
import { getUserInformation } from "@/api/reg/index";
import { imageEcho } from "@/api/index";
export default {
  data() {
    return {
      formLabelAlign: {
        imageUrl: "",
        type: 0,
        account: "",
        userName: "",
        mobilePhone: "",
        linkUserPhone: "",
        idCard: "",
        city: "",
        depositBank: "",
        bankAccount: "",
        bankAccountName: "",
      },
      carImg: "",
    };
  },
  mounted() {
    this.getUserInformationapi();
  },
  methods: {
    getUserInformationapi() {
      getUserInformation().then((res) => {
        this.formLabelAlign = res.data.data || {};
        this.formLabelAlign.city = this.formLabelAlign.city.replace(/\,/g, "/");
        /* 图片回显 */
        this.fileUploadapi(this.formLabelAlign.imageUrl);
      });
    },
    /* 回填图片回显 */
    fileUploadapi(imgPath) {
      imageEcho({
        imgPath,
      }).then((res) => {
        this.carImg = res.data.data.imageCode;
      });
    },
  },
};
</script>

<style lang="less" scoped>
.codeIcon {
  position: relative;
  padding: 0 10px 0 35px;
  width: 100%;
  margin: 0 0 16px;
}

.codeIcon::before {
  content: "";
  left: 3px;
  top: 3px;
  padding: 0px 2px;
  margin: 0 6px 0 0;
  background: #14d393;
  border-radius: 0 5px 5px 0;
}

.elFormBox {
  display: flex;
  justify-content: space-between;
}

.personalForm {
  width: 870px;
  margin: 0 auto;
}

.uploadCar {
  border-radius: 5px;
  border: 1px dashed #e5e5e5;
  width: 200px;
  height: 120px;
  display: flex;
  justify-content: center;
  flex-direction: column;
}

.el-icon-plus {
  font-size: 40px;
  font-weight: bold;
  color: #e6e6e6;
}

.idCars {
  display: flex;
  padding-bottom: 40px;
}

.btnBoxs {
  display: flex;
  justify-content: center;
  padding: 20px 0;

  /deep/.el-button {
    width: 110px;
  }

  .successBtn {
    color: #fff;
    background: #14d393;
    border: 1px solid #14d393;
  }
}

.avatar-box {
  position: absolute;

  top: 0;
  position: relative;

  img {
    width: 200px;
    height: 120px;
    display: block;
  }
}

.clearVideo {
  position: absolute;
  color: red;
  top: 3px;
  right: 2px;
  font-size: 16px;
  font-weight: 700;
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/views/servicecenter/regInfo/personalInfo.vue